import { Flex, FormItem, FormItemsGroup, Space, Spacing, Text } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { InvoiceDiscountMode } from '@features/invoices/enums/invoiceDiscountMode'

import { getDemoInvoiceLineColumnsTemplate } from '../../utils/getDemoInvoiceLineColumnsTemplate'

const COLUMN_HEADER_KEYS = [
  'external_invoices.editor.form.field.line.header.name',
  'external_invoices.editor.form.field.line.header.type',
  'external_invoices.editor.form.field.line.header.quantity',
  'external_invoices.editor.form.field.line.header.unit',
  'external_invoices.editor.form.field.line.header.unit_price',
  'external_invoices.editor.form.field.line.header.vat',
  'external_invoices.editor.form.field.line.header.total',
]

const COLUMN_HEADER_KEYS_WITH_DISCOUNT = [
  ...COLUMN_HEADER_KEYS.slice(0, 5),
  'external_invoices.editor.form.field.line.header.discount',
  ...COLUMN_HEADER_KEYS.slice(5),
]

interface DemoInvoiceLinesHeaderProps {
  discountMode: InvoiceDiscountMode
}

export const DemoInvoiceLinesHeader = ({ discountMode }: DemoInvoiceLinesHeaderProps): ReactElement => {
  const { t } = useTranslation()
  const columnsTemplate = getDemoInvoiceLineColumnsTemplate(discountMode)
  const headerKeys = discountMode === InvoiceDiscountMode.ByItem ? COLUMN_HEADER_KEYS_WITH_DISCOUNT : COLUMN_HEADER_KEYS
  const lastColumnIndex = headerKeys.length - 1

  return (
    <Flex>
      <FormItemsGroup itemsInRow={columnsTemplate.length} itemsTemplate={columnsTemplate} spacing={Spacing.S4}>
        {headerKeys.map((headerKey, index) => (
          <FormItem key={headerKey}>
            <Text alignment={index === lastColumnIndex ? 'right' : 'left'} variant="bodySM" weight="bold">
              {t(headerKey)}
            </Text>
          </FormItem>
        ))}
      </FormItemsGroup>
      <Space horizontal size="s8" />
      <Space horizontal size="s40" />
    </Flex>
  )
}
